// extracted by mini-css-extract-plugin
export default {"Link":"ErrorContainer_Link__6bTzn","ImageContainer":"ErrorContainer_ImageContainer__xZBrQ","Image":"ErrorContainer_Image__KNoom"};